import { getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  driverSheltersList: [],
  prevPage: -1,
  nextPage: -1,
  activeFilters: {},
  activeDriverShelter: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_DRIVER_SHELTERS_LIST:
      return setDriverSheltersList(state, action);
    case ActionTypes.SET_ACTIVE_DRIVER_SHELTER:
      return setActiveDriverShelter(state, action);
    default:
      return state;
  }
}

const setActiveDriverShelter = (state, action) => {
  return {
    ...state,
    activeDriverShelter: action.payload.driver_shelter,
  };
};

const setDriverSheltersList = (state, action) => {
  return {
    ...state,
    driverSheltersList: getPath(action.payload, "driver_shelters", []),
    prevPage: getPath(action.payload, "page_response.previous_page", -1),
    nextPage: getPath(action.payload, "page_response.next_page", -1),
  };
};
